import * as moment from 'moment';
import { IDonorRegistration } from '@nkr/models/index';
import { IPwlDetails, IRegistrationDetailsForPwl, IResultsUploaded, IShippedJug } from '@nkr/store/index';

enum PwlActions {
    Info = 0,
    MarkJugArrivedSendEmail = 1,
    ReadyForLabOrder = 2,
    UploadScrip = 3,
    UploadLabs = 4,
    ConvertDirectToCenter = 5,
    ViewLabOrders = 6,
    ViewLabResults = 7,
    ViewLabResultsDataGenerated = 8,
    MarkResultsReviewed = 9,
    RestartPwlJug = 10,
    RestartPwlCystatinC = 11,
    RuleOutCandidate = 12,
    ExpireDonor = 13
}

interface IJugArrivedState {
    show: boolean,
    data: IDonorRegistration,
    arrivalDate: string,
}

interface IState {
    registrationDetails: IRegistrationDetailsForPwl,
    pwlDetails: IPwlDetails,
    shippedJugsList: IShippedJug[],
    resultsUploadedList: IResultsUploaded[],
    markJugArrived: IJugArrivedState,
    showReadyForLabs: boolean,
    showUploadScrip: boolean,
    showUploadLabResults: boolean,
    showConvertToDirectToCenter: boolean,
    showMarkResultsReviewed: boolean,
    restartPwl: {
        show: boolean,
        isCystatinC: boolean
    },
    showRuleOut: boolean,
    showExpireDonor: boolean
}

const initialState: IState = {
    registrationDetails: null,
    pwlDetails: null,
    shippedJugsList: [],
    resultsUploadedList: [],
    markJugArrived: {
        show: false,
        data: null,
        arrivalDate: moment().format('YYYY-MM-DD')
    },
    showReadyForLabs: false,
    showUploadScrip: false,
    showUploadLabResults: false,
    showConvertToDirectToCenter: false,
    showMarkResultsReviewed: false,
    restartPwl: {
        show: false,
        isCystatinC: false
    },
    showRuleOut: false,
    showExpireDonor: false
};

const pwlDetailsReducer = (state: IState, action: { type: string, value: any }): IState => {
    if (action.type == 'afterLoad') {
        return {
            ...state,
            registrationDetails: action.value.registrationDetails,
            pwlDetails: action.value.pwlDetails,
            shippedJugsList: action.value.shippedJugsList,
            resultsUploadedList: action.value.resultsUploadedList
        };
    }

    if (action.type == 'updateMarkJugArrivedSendEmail') {
        return { ...state, markJugArrived: action.value };
    }

    if (action.type == 'updateShowReadyForLabs') {
        return { ...state, showReadyForLabs: action.value };
    }

    if (action.type == 'updateShowUploadScrip') {
        return { ...state, showUploadScrip: action.value };
    }

    if (action.type == 'updateShowUploadLabResults') {
        return { ...state, showUploadLabResults: action.value };
    }

    if (action.type == 'updateShowConvertToDirectToCenter') {
        return { ...state, showConvertToDirectToCenter: action.value };
    }

    if (action.type == 'updateShowMarkResultsReviewed') {
        return { ...state, showMarkResultsReviewed: action.value };
    }

    if (action.type == 'updateRestartPwl') {
        return { ...state, restartPwl: action.value };
    }

    if (action.type == 'updateShowRuleOut') {
        return { ...state, showRuleOut: action.value };
    }

    if (action.type == 'updateShowExpireDonor') {
        return { ...state, showExpireDonor: action.value };
    }

    return { ...state };
};

export {
    PwlActions,
    IState, initialState,
    pwlDetailsReducer
};